import { TAALY_UI_STRINGS } from "src/data";

function AuthImage() {
  return (
    <div className="hidden lg:flex lg:flex-col bg-brand-500 flex-1">
      <div className="mb-10 flex_center flex-col flex-1">
        <picture>
          <img src={"/logo.svg"} alt="Taaly Brand" width={200} height={100}></img>
        </picture>
        <q className="mt-8 text-white font-[600] text-3xl text-center max-w-[450px]">
          {TAALY_UI_STRINGS["taaly-mission"]}
        </q>
      </div>
    </div>
  );
}

export default AuthImage;
